import { useCallback } from 'react';
import type React from 'react';

import { Html } from 'src/app/shared/components/html';

type Props = {
	html: string;
	styles: string;
};

export const CmsHtml: React.FC<Props> = ({ html, styles }) => {
	// CMS content is sometimes linking directly to prod
	// which prevents from taking advantage of hash links in non-prod envs, or react-router navigation in all envs
	const transformLinkHref = useCallback((href: string) => href.replace(/^https:\/\/www.change.org\//, '/'), []);

	return (
		<>
			<style>{styles}</style>
			<Html
				html={html}
				noRestrictedAttrs
				noRestrictedTags
				noContentStyles
				supportHashLinks
				allowIframes
				linksTarget="_self"
				transformLinkHref={transformLinkHref}
				size="large"
			/>
		</>
	);
};
